(function() {
  'use strict';

  angular.module('ringbaPortal').component('ivrNode', {
    bindings: {
      collapseAll: '<',
      node: '<',
      onAddNodeToTree: '<',
      onRemoveNode: '<',
      onUpdateNode: '<',
      updateConnections: '<',
      nodeTypes: '<',
      ivrTree: '<', // This is to pass it to the ivr-router-filter component
      updateLink: '<',
      isSelectModeActive: '<', // This is for GOTO node selection
      activateSelectMode: '<', // This is for GOTO node selection
      selectGotoDestinationNode: '<', // This is for GOTO node selection
      highlightNode: '<', // This is for GOTO node selection
      uploadAudioFile: '<',
      ivrFiles: '<'
    },
    controller: IvrNodeController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/ivr/ivr-node.view.html'
  });

  function IvrNodeController(
    _,
    $filter,
    $timeout,
    bsLoadingOverlayService,
    ivrService
  ) {
    'ngInject';

    const vm = this;

    vm.highlightSelectedNodeType = {};

    vm.$onChanges = onChanges;
    vm.$onInit = onInit;
    vm.onParamChange = onParamChange;
    vm.clearOptionalSubType = clearOptionalSubType;
    vm.toggleHeader = toggleHeader;
    vm.removeChildNode = removeChildNode;
    vm.addNode = addNode;
    vm.onAddingNodeBegin = onAddingNodeBegin;
    vm.onAddingNodeComplete = onAddingNodeComplete;
    vm.activateTreeSelectMode = activateTreeSelectMode;
    vm.selectNodeAsGotoDestinationNode = selectNodeAsGotoDestinationNode;

    function onInit() {
      vm.collapsed = false;
    }

    function onChanges(changes) {
      if (changes.collapseAll) {
        vm.collapsed = vm.collapseAll.isCollapsed;
      }

      if (changes.node) {
        vm.internalNode = angular.copy(vm.node);
        vm.isRoot = vm.internalNode.nodeTypeId == 'RootNode';

        if (vm.internalNode.error) {
          vm.numErrors = _.size(vm.internalNode.error.propertyErrors) + _.size(vm.internalNode.error.errors);
        }
        if (!vm.isRoot) {
          if (vm.internalNode.nodeTemplate) {
            _processParameterGroups(vm.internalNode.nodeTemplate.parameters);
          }
          _.forOwn(vm.internalNode.childLinksLookup, function(child) {
            child.iconCssClass = ivrService.getNodeTypeIcon(child.childNodeType);
          });
        }
      }

      if (changes.isSelectModeActive && !vm.isSelectModeActive) {
        vm.isGotoNodeSelf = false;
      }
    }

    function onParamChange(param, value) {
      vm.internalNode.settings = vm.internalNode.settings || {};
      _.set(vm.internalNode.settings, param.name, value);

      if (param.isGroupedParam) {
        let groupSubType = param.name.split('.');
        groupSubType.pop();
        groupSubType = groupSubType.join('.');
        _.set(vm.internalNode.settings, groupSubType + '.groupName', param.groupName);
        // clear the other settings associated w/ this group
        let groupContainer = param.name.split('.');
        groupContainer.splice(-2, 2); // remove param name
        groupContainer = groupContainer.join('.');

        const clearedGroupSettings = _.omitBy(_.get(vm.internalNode.settings, groupContainer), function(val, key){
          return val.groupName && val.groupName == param.groupName && !key.startsWith(param.groupSubType);
        });
        _.set(vm.internalNode.settings, groupContainer, clearedGroupSettings);
      }

      vm.onUpdateNode(vm.internalNode);
    }

    function _processParameterGroups(params, groupParentSubtypeName) {
      let parameterGroups = {};
      // group params by "group"
      for (let i = 0; i < params.length; i++) {
        if (params[i].type == 'sub_type') {
          _processParameterGroups(params[i].parameters, params[i].name);
        }
        if (params[i].group) {
          const groupedParam = angular.copy(params[i]);
          groupedParam.groupParentSubtypeName = groupParentSubtypeName;
          for (let j = 0; j < groupedParam.parameters.length; j++) {
            groupedParam.parameters[j].isGroupedParam = true; // mark for detection onChange
            groupedParam.parameters[j].groupName = params[i].group;
            groupedParam.parameters[j].groupSubType = params[i].name; // assuming groups are always wrapped in subtype
          }
          if (parameterGroups[params[i].group]) {
            parameterGroups[params[i].group].push(groupedParam);
          } else {
            parameterGroups[params[i].group] = [groupedParam];
          }
        }
      }
      // create psuedo parameter of type "group" for each group
      if (_.keys(parameterGroups).length) {
        parameterGroups = _.mapValues(parameterGroups, function(o){
          return {
            name: o[0].group,
            groupParentSubtypeName: groupParentSubtypeName,
            type: 'group',
            isOptional: o[0].groupOptional,
            options: o
          };
        });
        const groupAdded = {};
        // replace plain old "group" params with pseudo group params
        for (let k = 0; k < params.length; k++) {
          const groupName = params[k].group;
          if (groupName && !groupAdded[groupName]) {
            groupAdded[groupName] = true;
            params.splice(k, 0, parameterGroups[groupName]);
          }
        }
        _.remove(params, function(p) {
          return p.group && groupAdded[p.group];
        });
      }
    }

    function clearOptionalSubType(param){
      // clear the other settings associated w/ this optional subtype
      if (param.isOptional) {
        vm.internalNode.settings = _.omitBy(vm.internalNode.settings, function(val, key){
          return key.startsWith(param.name);
        });
        vm.onUpdateNode(vm.internalNode);
      }
    }

    function toggleHeader() {
      vm.collapsed = !vm.collapsed;
      vm.updateConnections();
    }

    function removeChildNode(node) {
      vm.onRemoveNode(
        {
          id: node.childNodeId,
          parentId: vm.internalNode.id
        });
    }

    function addNode(nodeType, link) {
      if (!vm.disableNodeTypesButtons) {
        vm.onAddingNodeBegin(nodeType.nodeType);

        vm.onAddNodeToTree(vm.internalNode.id, nodeType.nodeTypeId, link.name, link.onSuccess, link.minimumCriteria, function () {
          onAddingNodeComplete(nodeType);
        });
      }
    }

    function onAddingNodeBegin(nodeType) {
      _showPopoverLoader();
      vm.disableNodeTypesButtons = true;
      vm.highlightSelectedNodeType[nodeType] = true;
    }

    function onAddingNodeComplete(nodeType) {
      vm.highlightSelectedNodeType[nodeType.nodeType] = false;
      vm.disableNodeTypesButtons = false;
      _hidePopoverLoader();
    }

    function activateTreeSelectMode() {
      vm.isGotoNodeSelf = true;
      vm.activateSelectMode(vm.internalNode.id);
    }

    function selectNodeAsGotoDestinationNode() {
      if (!vm.isGotoNodeSelf && vm.isSelectModeActive) {
        vm.selectGotoDestinationNode(vm.internalNode.id);
      }
    }

    function _showPopoverLoader() {
      bsLoadingOverlayService.start({
        referenceId: 'node-types-popover'
      });
    }

    function _hidePopoverLoader() {
      bsLoadingOverlayService.stop({
        referenceId: 'node-types-popover'
      });
    }
  }
})();
